module.exports = __webpack_public_path__ + "73e2d9c09ff3cdd2616a6c2a461e990a.png";